export function formatTrackDurationToString(durationSec: number): string {
  const duration = Math.abs(durationSec)
  const hours = Math.floor(duration / 3600)
  const minutes = Math.floor((duration - (hours * 3600)) / 60)
  const seconds = duration - (hours * 3600) - (minutes * 60)
  const hoursString = String(hours).padStart(2, '0')
  const minutesString = String(minutes).padStart(2, '0')
  const secondsString = String(seconds).padStart(2, '0')

  return hours ? `${hoursString}:${minutesString}:${secondsString}` : `${minutesString}:${secondsString}`
}
